<!--
   Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
-->

<h1 mat-dialog-title class="contact-us-dialog__title-container">
  <span>Support</span>
</h1>
<form id="contact-us-dialog-form" mat-dialog-content [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="half-sized">
    <mat-form-field gta="contact-us-form__name">
      <mat-label>Name (optional)</mat-label>
      <input matInput type="email" formControlName="name" cdkFocusInitial />
      <mat-error [gmc-errors]="form.controls.name" gmc-errors-label="Name">
        <ng-template gmcError="maxlength"
          >Name length should not exceed 200 characters, but got {{ form.controls.name.value?.length }}</ng-template
        >
      </mat-error>
    </mat-form-field>
    <mat-form-field gta="contact-us-form__email">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" />
      <mat-error [gmc-errors]="form.controls.email" gmc-errors-label="Email"></mat-error>
    </mat-form-field>
  </div>
  @if (clusterListByManagementTeams$ | async; as teams) {
    @if (teams.length) {
      <mat-form-field floatLabel="always">
        <mat-label>Cluster name</mat-label>
        <mat-select formControlName="clusterId" placeholder="Not a cluster issue">
          <mat-option [value]="null" class="option-no-cluster-issue">Not a cluster issue</mat-option>
          @for (team of teams; track identity(team)) {
            <mat-optgroup [label]="team.name">
              @for (cluster of team.clusters; track identity(cluster)) {
                <mat-option [value]="cluster.id">{{ cluster.tag }}</mat-option>
              }
            </mat-optgroup>
          }
        </mat-select>
      </mat-form-field>
    }
  }

  <mat-form-field gta="contact-us-form__subject">
    <mat-label>Subject (optional)</mat-label>
    <input matInput type="text" formControlName="subject" />
    <mat-error [gmc-errors]="form.controls.subject" gmc-errors-label="Subject">
      <ng-template gmcError="maxlength"
        >Subject length should not exceed 200 characters, but got {{ form.controls.subject.value?.length }}</ng-template
      >
    </mat-error>
  </mat-form-field>

  <mat-form-field gta="contact-us-form__message">
    <textarea
      matInput
      formControlName="message"
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="10"
    ></textarea>
    <mat-label>Message</mat-label>
    <mat-error [gmc-errors]="form.controls.message" gmc-errors-label="Message">
      <ng-template gmcError="maxlength"
        >Message length should not exceed {{ messageMaxLength }} characters, but got
        {{ form.controls.message.value?.length }}</ng-template
      >
    </mat-error>
  </mat-form-field>

  @if (form.controls.files.errors?.filesMaxTotalSize | map: asFilesMaxTotalSizeValidatorResut; as error) {
    <form-error gta="dialog-contact-us__global-validation-message">
      Attachments size is {{ error.actual | map: formatBytes }} MB, which is higher than
      {{ error.expected | map: formatBytes }} MB.
    </form-error>
  }
  @if (serverError$ | async; as error) {
    <form-error gta="dialog-contact-us__global-validation-message">{{ error }}</form-error>
  }

  <div class="file-upload-field">
    <file-input
      [formArray]="form.controls.files"
      [uploadProgressInPercents]="uploadProgressInPercents$ | async"
      [maxFileSizeInBytes]="maxFileSizeInBytes"
    ></file-input>
    <p class="upload-message material-emphasis-medium" gta="dialog-contact-us__file-size-limit-help"
      >The attachments size limit is {{ maxFilesTotalSizeInBytes | map: formatBytes }} MB. If you have a larger file to
      share, please let us know in the message.</p
    >
    @if (form.controls.files.controls; as files) {
      @if (files.length) {
        <ul class="file-list">
          @for (control of files; track identity(control); let index = $index) {
            <li class="not-mat-chip" [ngClass]="{ invalid: control.errors }" gta="dialog-contact-us__file"
              ><span class="file-name" detectEllipsis matTooltip gta="dialog-contact-us__file-name">{{
                control.getRawValue()?.name
              }}</span
              ><button
                class="remove-button"
                mat-icon-button
                (click)="form.controls.files.removeAt(index)"
                gta="dialog-contact-us__file-remove-button"
                [disabled]="isUploading$ | async"
              >
                <mat-icon>clear</mat-icon>
              </button></li
            >
          }
        </ul>
      }
    }
  </div>
</form>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close gta="dialog-contact-us__dismiss-button">Cancel</button>
  <button
    type="submit"
    mat-button
    form="contact-us-dialog-form"
    [disabled]="isSubmitButtonDisabled$ | async"
    gta="dialog-contact-us__submit-button"
    >Send</button
  >
</div>
